import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import { States } from "../../shared/config/constant.module";
import template from './downtimeShiftReportInsight.tpl.html';
import { StateParams } from "../../common";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import ReportServiceName, { ReportService } from "../../services/reports/report.service";
import DowntimeServiceName, { DowntimeService } from "../../services/downtimes/downtime.service";
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import * as Highcharts from 'highcharts/highstock';
import { Plant } from '../../models/navigation';
import { apsViewModels } from '../../shared/dto/APS.ViewModels';
import { DowntimeType } from "../../models/downtime";
import { data } from 'jquery';


let requires = [LoaderServiceName, DowntimeServiceName, ReportServiceName, AuthDataServiceName, NavigationServiceName, NotifyServiceName];

interface downtimeShiftReportInsightController {
  plants: Plant[];
  selectedPlant: Plant;
  selectedShop: apsViewModels.ShopNavigation;
  startDate: Date;
  endDate: Date;
  form: angular.IFormController;
  downtimeType: DowntimeType;
  downtimeTypes: DowntimeType[];
  updatePlant(): void;
  availableAreas: DowntimeType[];
  selectedAreas: DowntimeType[];
  availableShops: apsViewModels.ShopNavigation[];
  selectedShops: apsViewModels.ShopNavigation[];
  addArea(): void;
  removeArea(area: DowntimeType): void;
  addShop(): void;
  removeShop(shop: apsViewModels.ShopNavigation): void;
}

export interface downtimeShiftReportInsightParams extends StateParams {
  reportPlantId: string;
  reportShopId: string;
  startDate: string;
  endDate: string;
}

class downtimeShiftReportInsightCtrl implements downtimeShiftReportInsightController {
  plants: Plant[];
  selectedPlant: Plant;
  selectedShop: apsViewModels.ShopNavigation;
  startDate: Date;
  endDate: Date;
  uiStartDate: Date;
  uiEndDate: Date;
  form: angular.IFormController;
  downtimeType: DowntimeType;
  downtimeTypes: DowntimeType[];
  availableAreas: DowntimeType[];
  selectedAreas: DowntimeType[];
  availableShops: apsViewModels.ShopNavigation[];
  selectedShops: apsViewModels.ShopNavigation[];

  $state: angular.ui.IStateService;
  loaderService: LoaderService;
  reportService: ReportService;
  downtimeService: DowntimeService;
  authDataService: AuthDataService;
  notifyService: NotifyService;
  $q: angular.IQService;

  reportLoadingPromise: angular.IDeferred<any>;
  reportAvailableThisWorkaround: any;

  private $stateParams: downtimeShiftReportInsightParams;

  constructor(
    $state: angular.ui.IStateService,
    $stateParams: downtimeShiftReportInsightParams,
    navigationService: NavigationService,
    reportService: ReportService,
    downtimeService: DowntimeService,
    loaderService: LoaderService,
    authDataService: AuthDataService,
    notifyService: NotifyService,
    $q: angular.IQService) {

    var vm = this;

    this.$state = $state;
    this.$stateParams = $stateParams;
    this.loaderService = loaderService;
    this.reportService = reportService;
    this.downtimeService = downtimeService;
    this.authDataService = authDataService;
    this.notifyService = notifyService;
    this.$q = $q;


    var now = moment().add(1, 'hours').startOf('hour');
    this.uiEndDate = now.toDate();
    this.uiStartDate = now.clone().subtract(1, 'days').toDate();
    var promise = navigationService.getNavigation().then((navModel) => {
      this.plants = navModel.plants();
      this.selectedPlant = navModel.selectedPlant;
      // this.selectedShop = navModel.selectedShop;

      return this.loadState($stateParams).then(function (data) {
        vm.downtimeTypes = data.downtimeTypes;
        let streamId = '00000000-0000-0000-0000-000000000000';
        let toolChangeId = 'bbdf0000-3a00-000d-c122-08d2e5fba957';
        vm.downtimeTypes.push(new DowntimeType(streamId, 'Streaming'));
        vm.downtimeTypes.push(new DowntimeType(toolChangeId, 'Tool Change'));
        vm.availableAreas = vm.downtimeTypes;
        vm.selectedAreas = [];
        vm.availableShops = _.clone(vm.selectedPlant.shops);
        vm.selectedShops = [];
      });

    });

    loaderService.loadingPromise(promise);

  }

  loadState(params: downtimeShiftReportInsightParams): angular.IPromise<any> {
    if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
      var plant = _.find(this.plants, { id: params.reportPlantId });
      if (plant) {
        var shop = _.find(plant.shops, { id: params.reportShopId });
        if (shop) {
          this.selectedPlant = plant;
          // this.selectedShop = shop;
        }
      }
    }

    if (params.startDate) {
      var startDate = moment(params.startDate);
      if (startDate.isValid()) {
        this.startDate = startDate.toDate();
      }
    }

    return this.getDowntimeTypes();

  }

  updatePlant = () => {
    this.availableShops = this.selectedPlant.shops;
    if (this.selectedShops.length > 0) {
      this.selectedShops = [];
    }
  }

  addArea = () => {
    if (this.downtimeType === null || this.downtimeType === undefined) {
      this.selectedAreas = [];
      this.downtimeTypes.forEach(element => {
        this.selectedAreas.push(element);
      });
      this.availableAreas = [];
    }
    else {
      var exisitng = this.selectedAreas.filter(x => x.downtimeTypeId == this.downtimeType.downtimeTypeId);
      if (exisitng.length === 0) {
        this.selectedAreas.push(this.downtimeType);
        _.remove(this.availableAreas, this.downtimeType);
      }
    }
  }

  removeArea = (area: DowntimeType) => {
    _.remove(this.selectedAreas, area);
    this.availableAreas.push(area);
  };

  addShop = () => {
    if (this.selectedShop === null || this.selectedShop === undefined) {
      this.selectedShops = [];
      this.selectedPlant.shops.forEach(element => {
        this.selectedShops.push(element);
      });
      this.availableShops = [];
    }
    else {
      var exisitng = this.selectedShops.filter(x => x.id == this.selectedShop.id);
      if (exisitng.length === 0) {
        this.selectedShops.push(this.selectedShop);
        _.remove(this.availableShops, this.selectedShop);
      }
    }
  }

  removeShop = (shop: apsViewModels.ShopNavigation) => {
    _.remove(this.selectedShops, shop);
    this.availableShops.push(shop);
  };

  saveState(): void {
    var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
    if (reportPlantId === this.$stateParams.plantId) {
      reportPlantId = undefined;
    }
    var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
    if (reportShopId === this.$stateParams.shopId) {
      reportShopId = undefined;
    }

    var params: downtimeShiftReportInsightParams = {
      plantId: this.$stateParams.plantId,
      shopId: this.$stateParams.shopId,
      userId: this.$stateParams.userId,
      reportPlantId: reportPlantId,
      reportShopId: reportShopId,
      startDate: this.startDate ? this.startDate.toISOString() : undefined,
      endDate: this.endDate ? this.endDate.toISOString() : undefined
    };

    this.$state.transitionTo(this.$state.current.name, params);
  }

  generateReport(regenerate: boolean) {
    if (this.form.$invalid) {
      return;
    }

    var diff = moment(this.endDate).diff(this.startDate, 'days')

    if (diff > 185) {
      this.notifyService.error('Date range cannot exceed 6 months');
      return;
    }

    this.saveState();
    this.loaderService.loadingPromise(this.runReport());
  }

  private runReport(): angular.IPromise<any> {

    let req = {
      plantId: this.selectedPlant.id,
      startDate: this.startDate,
      endDate: this.endDate,
      shopIds: [],
      areaIds: []
    };

    // if (this.selectedShop) {
    //   req.shopIds.push(this.selectedShop.id);
    // }
    // if(this.downtimeType){
    //   req.areaIds.push(this.downtimeType.downtimeTypeId);
    // }
    if (this.selectedShops.length > 0) {
      this.selectedShops.forEach(element => {
        req.shopIds.push(element.id);
      });
    }
    if (this.selectedAreas.length > 0) {
      this.selectedAreas.forEach(element => {
        req.areaIds.push(element.downtimeTypeId);
      });
    }

    let promise = this.reportService.getDowntimeInsight(req);

    promise.then((result: apsViewModels.DowntimeInsightResponse) => {
      this.createChart('container_area', this.getSeriesOptionByArea(result.trend_Area));
      this.createChart('container_reason', this.getSeriesOptionByReason(result.trend_Reason))
      this.createBarChart('container_Top_Reason', this.getSeries(result.top5_Reason, 'reason'), this.getCategoryByReason(result.top5_Reason));
      this.createBarChart('container_Top_Area', this.getSeries(result.top5_Area, 'area'), this.getCategoryByArea(result.top5_Area));
    });

    return promise;
  }


  getSeries(data: apsViewModels.DowntimeCount[], type: string) {
    let seriesData = [];
    let item = {
      name: '',
      colorByPoint: true,
      data: [],
      dataLabels: []
    };

    data.forEach(x => {
      x.details.forEach(y => {
        item.data.push(y.downtimeTotal);
      }
      );
    });

    data.forEach(x => {
      x.details.forEach(y => {
        item.dataLabels.push({
          align: 'center',
          zIndex: -1,
          formatter: function () {
            return formatter(this, data, type);
          }
        });
      }
      );
    });
    seriesData.push(item);

    return seriesData;
  }

  getCategoryByArea(data: apsViewModels.DowntimeCount[]) {
    let categoryData = [];

    data.forEach(x => {
      categoryData.push(x.area);
    });

    return categoryData;
  }

  getCategoryByReason(data: apsViewModels.DowntimeCount[]) {
    let categoryData = [];

    data.forEach(x => {
      categoryData.push(x.reason);
    });

    return categoryData;
  }

  getSeriesOptionByArea(data: apsViewModels.DowntimeCount[]) {
    let seriesOptions = [];
    let i = 0;

    data.forEach(x => {
      let item = [];

      x.details.forEach(y => {
        let datapoint = {
          x: y.epoch,
          y: y.downtimeTotal
        };
        item.push(datapoint);
      }
      );

      seriesOptions[i] = {
        name: x.area,
        data: item
      }
      i++;

    });

    return seriesOptions;
  }

  getSeriesOptionByReason(data: apsViewModels.DowntimeCount[]) {
    let seriesOptions = [];
    let i = 0;

    data.forEach(x => {
      let item = [];

      x.details.forEach(y => {
        let datapoint = {
          x: y.epoch,
          y: y.downtimeTotal
        };
        item.push(datapoint);
      }
      );

      seriesOptions[i] = {
        name: x.reason,
        data: item
      }
      i++;

    });

    return seriesOptions;
  }

  createBarChart(containerName: string, seriesData: any[], categoryData: string[]) {
    Highcharts.chart(containerName,
      {
        chart: {
          type: 'column',
          zoomType: 'y'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: categoryData,
          title: {
            text: ''
          }
        },
        yAxis: [{
          min: 0,
          title: {
            text: 'Downtime in Minutes'
          }
        }],
        legend: {
          enabled: false,
          shadow: false
        },
        plotOptions: {
          column: {
            grouping: false,
            shadow: false,
            pointWidth: 30,
            dataLabels: {
              enabled: true
            }
          }
        },
        series: seriesData,
        credits: { enabled: false }
      });
  }
  createChart(containerId: string, seriesOptions: any[]) {

    Highcharts.chart(containerId,
      {
        title: {
          text: ''
        },
        time: {
          useUTC: false
        },
        xAxis: {
          type: 'datetime',
          title: {
            text: ''
          },
          dateTimeLabelFormats: {
            second: '%l:%M:%S %p',
            minute: '%l:%M %p',
            hour: '%l %p',
            day: '%m/%d/%Y',
            month: '%m/%d/%Y',
            year: '%m/%d/%Y'
          }
        },
        yAxis: {
          labels: {
            formatter: function () {
              return (this.value > 0 ? ' + ' : '') + this.value;
            }
          },

          title: {
            text: 'Downtime in Minutes'
          },
          plotLines: [{
            value: 0,
            width: 2,
            color: 'silver'
          }]
        },
        series: seriesOptions,
        credits: { enabled: false }
      });
  }


  getDowntimeTypes(): angular.IPromise<any> {
    return this.downtimeService.getDowntimeTypesAndReasons();
  }


}

export default angular.module('aps.controller.downtimeShiftReportInsight', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.DOWNTIME_SHIFT_REPORT_INSIGHT,
      url: '/downtimeShiftReportInsight',
      params: {
        startDate: { dynamic: true },
        reportPlantId: { dynamic: true }
      },
      controller: 'downtimeShiftReportInsightCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Downtime Shift Report Trends'
      }
    });
  })
  .controller('downtimeShiftReportInsightCtrl', downtimeShiftReportInsightCtrl)
  .name;


function formatter(baseSeries, data: apsViewModels.DowntimeCount[], type: string) {
  var predicate = { [type]: baseSeries.key };
  var seriesdata = _.find(data, predicate);
  return seriesdata.details[0].downtimeTotal;
}




// WEBPACK FOOTER //
// ./src/app/controllers/reports/downtimeShiftReportInsight.controller.ts